import { useRef, useState } from 'react';
import { Row } from 'antd';
import { colors } from '../../shared/styles/baseStyle';
import {
  handleKeyDown,
  handlePaste
} from '../../shared/utils/keyboardInputHelper';
import boxStyle from './styles';

export default function OtpInput({ value = '', onChange, length = 6 }) {
  const inputsRef = useRef([]);
  const [focusedIndex, setFocusedIndex] = useState(null);
  const otp = Array.from({ length }, (_, i) => value[i] || '');

  const emit = next => onChange?.(next.join(''));
  const focusInput = i => inputsRef.current[i]?.focus();

  const handleChange = (val, index) => {
    const digit = val.replace(/\D/g, '').slice(-1);
    const next = [...otp];
    next[index] = digit;
    emit(next);
    if (digit && index < length - 1) focusInput(index + 1);
  };

  return (
    <Row justify="center" align="middle">
      {otp.map((digit, i) => (
        <input
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          ref={el => {
            inputsRef.current[i] = el;
          }}
          value={digit}
          inputMode="numeric"
          maxLength={1}
          onChange={e => handleChange(e.target.value, i)}
          onKeyDown={e => handleKeyDown(e, i, otp, emit, focusInput, length)}
          onPaste={e => handlePaste(e, length, emit, focusInput)}
          onFocus={e => {
            setFocusedIndex(i);
            e.target.select();
          }}
          onBlur={() => setFocusedIndex(null)}
          style={{
            ...boxStyle,
            border: `1px solid ${
              focusedIndex === i ? colors.anytimeBlue : '#ebebeb'
            }`
          }}
        />
      ))}
    </Row>
  );
}
